/* Novoma — LP Collagène articulaire.
   Reprend les interactions de la maquette (app.js) ; le bloc d'achat lit
   le produit Shopify et ses plans Recharge, puis ajoute au panier. */
(function () {
  'use strict';
  if (window.__nvLpLoaded) return;
  window.__nvLpLoaded = true;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ================= Bloc d'achat ================= */
  function initOffer() {
    var form = $('#offre'), dataEl = $('#nv-product-data');
    if (!form || !dataEl) return;
    var data; try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var cfg = data.config;
    var money = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: data.currency || 'EUR' });
    var fmt = function (c) { return money.format(c / 100); };
    var firstNum = function (s) { var m = String(s || '').match(/\d+/); return m ? +m[0] : 0; };
    var anyPlan = data.variants.some(function (v) { return v.plans.length; });
    var toggle = form.querySelector('input[name="subscribe"]');
    if (!anyPlan && toggle) { toggle.checked = false; $('.subscription-field', form).hidden = true; }

    function variantFor(flavor) {
      var list = data.variants.filter(function (v) { return !flavor || v.options.indexOf(flavor) > -1; });
      return list.filter(function (v) { return v.available; })[0] || list[0] || data.variants[0];
    }
    function planFor(v, qty) {
      if (!v.plans.length) return null;
      // 1) Fréquence Recharge (ex. « 1-month », « 3-month ») = nombre de mois de la cure
      var withFreq = v.plans.filter(function (p) { return p.months > 0; });
      if (withFreq.length) return withFreq.filter(function (p) { return p.months === qty; })[0] || null;
      // 2) À défaut : mot-clé dans le nom du plan, puis plus petit / plus grand intervalle
      var isLong = qty === cfg.qtyLong;
      var kw = String((isLong ? cfg.matchLong : cfg.matchShort) || '').toLowerCase().trim();
      if (kw) { var hit = v.plans.filter(function (p) { return p.name.toLowerCase().indexOf(kw) > -1; })[0]; if (hit) return hit; }
      var sorted = v.plans.slice().sort(function (a, b) { return firstNum(a.name) - firstNum(b.name); });
      return isLong ? sorted[sorted.length - 1] : sorted[0];
    }
    // One-time price per sachet: product price, minus the pack discount for the long cure (as on the product page).
    function onceUnit(v, qty) {
      var pct = qty === cfg.qtyLong ? (cfg.onceLongPct || 0) : 0;
      return Math.round(v.price * (1 - pct / 100));
    }
    // Abonnement : remise Recharge seule, ou cumulée avec la remise pack si « Cumuler » est coché.
    function unitPrice(v, qty, plan) {
      var once = onceUnit(v, qty);
      if (!plan) return once;
      return Math.round((cfg.stackPack ? once : v.price) * plan.price / v.price);
    }
    function selection() {
      var d = new FormData(form);
      var qty = Number(d.get('duration')) || cfg.qtyLong;
      var sub = !!(toggle && toggle.checked);
      var v = variantFor(d.get('flavor'));
      var plan = sub ? planFor(v, qty) : null;
      var unit = unitPrice(v, qty, plan);
      return { flavor: d.get('flavor') || '', qty: qty, months: qty, subscription: !!plan, wantsSub: sub, variant: v, plan: plan, unit: unit, cents: unit * qty, full: v.price * qty };
    }
    function pct(full, now) { return full > now ? Math.round((1 - now / full) * 100) : 0; }
    function freeShipping(s) { return s.subscription || s.cents >= cfg.freeShippingFrom; }
    function shippingCopy(s) { return freeShipping(s) ? (s.subscription ? 'Livraison gratuite à chaque commande' : 'Livraison offerte') : 'Frais de livraison au paiement'; }
    function period(m) { return m === 1 ? 'chaque mois' : 'tous les ' + m + ' mois'; }

    function render() {
      var s = selection();
      var discount = pct(s.full, s.cents);
      var dEl = $('#subscription-discount'); if (dEl) dEl.textContent = 'Économisez ' + discount + ' % sur votre abonnement';
      var bEl = $('#subscription-benefits'); if (bEl) bEl.hidden = !s.subscription;
      [cfg.qtyLong, cfg.qtyShort].forEach(function (q) {
        var plan = s.wantsSub ? planFor(s.variant, q) : null;
        var unit = unitPrice(s.variant, q, plan);
        var cents = unit * q, full = s.variant.price * q, saved = full - cents, off = pct(full, cents);
        var tag = $('[data-duration-saving="' + q + '"]'); if (tag) { tag.textContent = '−' + off + ' %'; tag.hidden = !saved; }
        var sv = $('[data-total-saving="' + q + '"]'); if (sv) { sv.textContent = fmt(saved) + ' économisés'; sv.hidden = !saved; }
        var ref = $('[data-duration-reference="' + q + '"]'); if (ref) { ref.textContent = fmt(s.variant.price); ref.hidden = !saved; }
        var pr = $('[data-duration-price="' + q + '"]'); if (pr) pr.textContent = fmt(unit);
        var un = $('[data-duration-unit="' + q + '"]'); if (un) un.textContent = fmt(unit / cfg.daysPerUnit) + ' / jour';
      });
      var m = s.months, sp = m > 1 ? 's' : '';
      var ren = $('#renewal'); if (ren) ren.textContent = s.subscription ? m + ' sachet' + sp + ' livré' + sp + ' ' + period(m) : 'Achat unique · Aucun renouvellement';
      var bill = $('#billing'); if (bill) bill.textContent = fmt(s.cents) + (s.subscription ? ' facturés ' + period(m) : ' en une seule fois') + '. ' + shippingCopy(s) + '.';
      var sh = $('#shipping'); if (sh) sh.textContent = shippingCopy(s);
      var sd = $('#sticky-detail'); if (sd) sd.textContent = s.flavor + (s.flavor ? ' · ' : '') + m + ' mois · ' + (s.subscription ? 'Abonnement' : 'Achat unique');
      var sPr = $('#sticky-price'); if (sPr) sPr.textContent = fmt(s.unit) + ' / sachet';
      var sDi = $('#sticky-discount'); if (sDi) { sDi.textContent = '−' + discount + ' %'; sDi.hidden = !discount; }
      var btn = $('.purchase-cta', form), err = $('#nv-error');
      var blocked = !s.variant.available || (data.requiresPlan && !s.plan) || (s.wantsSub && anyPlan && !s.plan);
      btn.disabled = blocked;
      if (err) {
        err.hidden = !blocked;
        err.textContent = !s.variant.available ? 'Cette saveur est épuisée.' : (blocked ? 'L’abonnement n’est pas disponible pour cette durée. Choisissez l’autre cure ou l’achat unique.' : '');
      }
      form.__nv = s;
    }

    form.addEventListener('change', function (e) {
      render();
      if (e.target.name === 'flavor') {
        var idx = slides.findIndex(function (b) { return b.dataset.flavor === selection().flavor; });
        if (idx > -1) showSlide(idx);
      }
    });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var s = form.__nv, btn = $('.purchase-cta', form), err = $('#nv-error');
      if (!s || btn.disabled) return;
      btn.disabled = true; btn.setAttribute('aria-busy', 'true');
      var item = { id: s.variant.id, quantity: s.qty };
      if (s.plan) item.selling_plan = s.plan.id;
      var json = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
      if (window.nvCart && window.nvCart.beforeAdd) window.nvCart.beforeAdd();
      (cfg.clearCart ? fetch(location.origin + root + 'cart/clear.js', { method: 'POST', headers: json }) : Promise.resolve())
        .then(function () { return fetch(location.origin + root + 'cart/add.js', { method: 'POST', headers: json, body: JSON.stringify({ items: [item] }) }); })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Erreur'); return j; }); })
        .then(function () {
          if ((cfg.after || 'drawer') === 'drawer' && window.nvCart && window.nvCart.available()) {
            btn.disabled = false; btn.removeAttribute('aria-busy');
            window.nvCart.afterAdd();
            return;
          }
          window.location.href = root + (cfg.after === 'checkout' ? 'checkout' : 'cart');
        })
        .catch(function (e2) {
          if (err) { err.hidden = false; err.textContent = e2.message || 'Une erreur est survenue, merci de réessayer.'; }
          btn.disabled = false; btn.removeAttribute('aria-busy');
        });
    });

    /* Galerie */
    var slides = $$('.gallery-thumb'), current = 0, requestId = 0;
    var gallery = $('.shop-gallery'), stage = $('.gallery-stage'), productImage = $('#shop-product');
    var preloads = slides.map(function (b) { var i = new Image(); i.src = b.dataset.image; return i; });
    function showSlide(index) {
      if (!slides.length || !productImage) return;
      current = (index + slides.length) % slides.length;
      var target = current, request = ++requestId, button = slides[target], cached = preloads[target];
      gallery.setAttribute('aria-busy', 'true');
      var done = function () {
        if (request !== requestId) return;
        productImage.src = button.dataset.image; productImage.alt = button.dataset.alt || '';
        slides.forEach(function (b, i) { b.classList.toggle('active', i === target); b.setAttribute('aria-pressed', String(i === target)); });
        var c = $('#gallery-count'); if (c) c.textContent = (target + 1) + ' / ' + slides.length;
        gallery.setAttribute('aria-busy', 'false');
        gallery.classList.toggle('nv-not-first', target !== 0);
      };
      if (cached.complete && cached.naturalWidth) done();
      else (cached.decode ? cached.decode() : Promise.resolve()).then(done, function () { if (request === requestId) gallery.setAttribute('aria-busy', 'false'); });
    }
    slides.forEach(function (b, i) { b.addEventListener('click', function () { showSlide(i); }); });
    var gp = $('#gallery-prev'), gn = $('#gallery-next');
    if (gp) gp.addEventListener('click', function () { showSlide(current - 1); });
    if (gn) gn.addEventListener('click', function () { showSlide(current + 1); });
    if (gallery) gallery.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); showSlide(current + (e.key === 'ArrowRight' ? 1 : -1)); } });
    var touchStart = null;
    if (stage) {
      stage.addEventListener('touchstart', function (e) { touchStart = e.touches.length === 1 ? { x: e.touches[0].clientX, y: e.touches[0].clientY } : null; }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (!touchStart) return;
        var dx = e.changedTouches[0].clientX - touchStart.x, dy = e.changedTouches[0].clientY - touchStart.y; touchStart = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.3) showSlide(current + (dx < 0 ? 1 : -1));
      }, { passive: true });
      stage.addEventListener('touchcancel', function () { touchStart = null; }, { passive: true });
    }

    render();
    var startIdx = slides.findIndex(function (b) { return b.dataset.flavor && b.dataset.flavor === selection().flavor; });
    showSlide(startIdx > -1 ? startIdx : 0);
  }

  /* ================= Panier latéral : celui du site (cart-drawer.js du thème) =================
     Le thème intercepte les appels /cart/add.js et ouvre lui-même son panier : on vérifie juste
     qu'il s'est bien ouvert, et on garde le défilement de la LP intact (overflow posé sur <body> par le thème). */
  function initCart() {
    var drawer = function () { return document.querySelector('cart-drawer-z'); };
    var panel = function () { return document.getElementById('cart-drawer-v2'); };
    var isOpen = function () { var p = panel(); return !!(p && p.classList.contains('active')); };

    /* Le thème ouvre son panier (classe « active ») puis émet « cart:update » sur <body>.
       Sans cet événement (script du thème absent ou bloqué), on ouvre/redirige nous-mêmes. */
    var handled = false;
    document.body.addEventListener('cart:update', function () { handled = true; });
    var pnl = panel();
    if (pnl) new MutationObserver(function () { if (pnl.classList.contains('active')) handled = true; }).observe(pnl, { attributes: true, attributeFilter: ['class'] });
    function beforeAdd() { handled = false; }
    function afterAdd() {
      setTimeout(function () {
        if (handled || isOpen()) return;
        var d = drawer();
        if (d && typeof d.renderContents === 'function') d.renderContents();
        else window.location.href = root + 'cart';
      }, 2500);
    }

    /* Icône panier : si le panier du thème est absent, on renvoie vers /cart */
    $$('[data-cart-drawer-open]').forEach(function (b) {
      b.addEventListener('click', function () { if (!drawer()) window.location.href = root + 'cart'; });
      b.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); b.click(); } });
    });

    /* Le thème bloque le défilement via body.style.overflow ; sur la LP on le fait sur <html>
       (sinon l'en-tête fixe et le scroll horizontal se dérèglent après fermeture). */
    var body = document.body, html = document.documentElement;
    new MutationObserver(function () {
      var o = body.style.overflow;
      if (!o) return;
      html.classList.toggle('nv-cd-lock', o === 'hidden');
      body.style.removeProperty('overflow');
    }).observe(body, { attributes: true, attributeFilter: ['style'] });

    window.nvCart = {
      available: function () { return !!drawer(); },
      open: function () { var d = drawer(); if (d && d.renderContents) d.renderContents(); },
      beforeAdd: beforeAdd,
      afterAdd: afterAdd
    };
  }

  /* Barre sticky : visible dès que le hero n'est plus à l'écran */
  function initSticky() {
    var sticky = $('.sticky'), hero = $('.hero');
    if (!sticky || !hero) return;
    // Visible as soon as the hero CTA has scrolled out of view (above, or under the fixed header),
    // hidden again while the offer block (#offre) is on screen.
    var cta = hero.querySelector('.hero-cta') || hero.querySelector('.primary') || hero;
    var offer = $('#offre') || $('.shopping-content');
    function headH() {
      var v = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--nv-head-h'));
      return isNaN(v) ? 0 : v;
    }
    function update() {
      var r = cta.getBoundingClientRect();
      var ctaGone = r.bottom < headH() + 4;
      var offerIn = false;
      if (offer) { var o = offer.getBoundingClientRect(); offerIn = o.top < window.innerHeight * 0.85 && o.bottom > 0; }
      sticky.hidden = !ctaGone || offerIn;
    }
    var ticking = false;
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(function () { ticking = false; update(); }); } }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* ================= Composition, pharmacies, fenêtres ================= */
  // Close a dialog when clicking outside it (on the dark backdrop).
  function closeOnBackdrop(d) {
    if (!d || d.__nvBackdrop) return; d.__nvBackdrop = true;
    d.addEventListener('click', function (e) {
      var r = d.getBoundingClientRect();
      var inside = e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom;
      if (!inside) d.close();
    });
  }
  function initComposition() {
    closeOnBackdrop($('#nutrition-dialog'));
    closeOnBackdrop($('#ingredient-dialog'));
    var nd = $('#nutrition-dialog'), no = $('.nutrition-open'), nc = $('.nutrition-close');
    if (nd && no) no.addEventListener('click', function () { nd.showModal(); });
    if (nd && nc) nc.addEventListener('click', function () { nd.close(); });
    $$('[data-track="ingredients"]').forEach(function (button) {
      button.addEventListener('click', function () {
        var track = $('.pdp-ingredient-track'); if (!track || !track.firstElementChild) return;
        track.scrollBy({ left: Number(button.dataset.direction) * (track.firstElementChild.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap || 0)), behavior: 'smooth' });
      });
    });
    var pt = $('.pdp-pharmacy-track'), dots = $$('[data-pharmacy]');
    if (pt && dots.length) {
      dots.forEach(function (b) { b.addEventListener('click', function () { pt.scrollTo({ left: Number(b.dataset.pharmacy) / Math.max(1, dots.length - 1) * (pt.scrollWidth - pt.clientWidth), behavior: 'smooth' }); }); });
      pt.addEventListener('scroll', function () {
        var max = pt.scrollWidth - pt.clientWidth, index = max ? Math.round(pt.scrollLeft / max * (dots.length - 1)) : 0;
        dots.forEach(function (b, i) { b.setAttribute('aria-pressed', String(i === index)); });
      }, { passive: true });
    }
    var idg = $('#ingredient-dialog');
    if (idg) {
      $$('.ingredient-open').forEach(function (button) {
        button.addEventListener('click', function () {
          var card = button.closest('.pdp-ingredient');
          idg.querySelector('h2').textContent = card.querySelector('h3').innerText.replace(/\s+/g, ' ').trim();
          idg.querySelector('.ingredient-dialog-source').replaceChildren(card.querySelector('dl').cloneNode(true));
          idg.querySelector('.ingredient-dialog-description').textContent = card.querySelector('p').textContent;
          idg.querySelector('.ingredient-dialog-extra').innerHTML = card.querySelector('.ingredient-extra').innerHTML;
          idg.showModal();
        });
      });
      var ic = $('.ingredient-close'); if (ic) ic.addEventListener('click', function () { idg.close(); });
    }
  }

  /* ================= Avis Yotpo ================= */
  /* Avis : le carrousel est géré directement dans la section nv-reviews (script intégré). */
  function initReviews() {}

  function safe(fn, name) { try { fn(); } catch (e) { if (window.console) console.error('[LP Novoma] ' + name, e); } }
  function init() { safe(initCart, 'panier'); safe(initSticky, 'sticky'); safe(initOffer, 'offre'); safe(initComposition, 'composition'); safe(initReviews, 'avis'); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
